import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import cloneDeep from 'lodash.clonedeep';

import { withNotificationForError } from './helper';
import axios from 'axios';
import api from 'API';

const initialState = {
  loading: false,
  collapsed: false,
  device: 'phone',
  menuConfig: {
    top: [],
    bottom: [],
    additional: [],
  },
};

export const setRegisterConfig = createAsyncThunk(
  'menu/setRegisterConfig',
  withNotificationForError(async () => {
    return await require('../router/auth/menu').default;
  })
);

export const setMenuConfig = createAsyncThunk(
  'menu/setMenuConfig',
  withNotificationForError(async (payload, { getState }) => {
    const userType = getState().userToken.tokenType;

    // load menu
    const defaultMenuConfig = await require('../router/dashboard/' + userType + '/menu').default;
    let _defaultMenuConfig = cloneDeep(defaultMenuConfig);

    // fetch menu
    let requestUrl = api.users.navigationMenu(userType);
    const response = await axios(requestUrl.AXIOS('get'));

    const top = response.data.data.top;

    return {
      ..._defaultMenuConfig,
      top: top,
    };
  }),
  {
    condition: (payload, { getState }) => {
      const userType = getState().userToken.tokenType;
      if (!userType) return false;
    },
  }
);

const menuSlice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    toggleSidebar(state, action) {
      state.collapsed = action.payload.collapsed;
      state.device = action.payload.device || state.device;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setMenuConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(setMenuConfig.fulfilled, (state, action) => {
        state.menuConfig = action.payload;
        state.loading = false;
      })
      .addCase(setMenuConfig.rejected, (state) => {
        state.menuConfig = initialState.menuConfig;
        state.loading = false;
      })
      .addCase(setRegisterConfig.fulfilled, (state, action) => {
        state.menuConfig = action.payload;
      })
      .addCase(setRegisterConfig.rejected, (state) => {
        state.menuConfig = initialState.menuConfig;
      });
  },
});

export const { toggleSidebar } = menuSlice.actions;
export default menuSlice.reducer;
